import { Currency } from "@redotech/money/currencies";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum InstantExchangeRecoveryStatus {
  SUCCESS = "RECOVERED",
  FAILED = "FAILED",
}

export const InstantExchangeRecoveryHistorySchema = z.object({
  orderName: z.string(),
  returnId: z.string(),
  customerEmail: z.string(),
  customerName: z.string(),
  recoveryStatus: createEnum(InstantExchangeRecoveryStatus),
  currency: createEnum(Currency),
  amount: z.number(),
  initialAttemptedRecoveryDate: z.date(),
});

export const getReturnsInstantExchangeRecoveryHistory = {
  name: "getReturnsInstantExchangeRecoveryHistory" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    instantExchangeRecoveryHistory: z.array(
      InstantExchangeRecoveryHistorySchema,
    ),
  }),
};
